import React, { useRef } from 'react';
import { LabeledCallToActionCard } from '../../molecules';
import { Body, Container, EntryAnimation, Heading } from '../../atoms';
export default function LabeledCallToActionCardsGridSection(param) {
    var title = param.title, description = param.description, cards = param.cards, className = param.className;
    var containerRef = useRef(null);
    return /*#__PURE__*/ React.createElement(Container, {
        ref: containerRef,
        name: LabeledCallToActionCardsGridSection.name,
        className: className
    }, /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-1 grid-flow-row auto-rows-max gap-6"
    }, !!title && /*#__PURE__*/ React.createElement(Heading, {
        as: "h2",
        variant: "h2"
    }, title), !!description && /*#__PURE__*/ React.createElement(Body, {
        className: "prose"
    }, description), /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-1 grid-flow-row auto-rows-max gap-6 md:grid-cols-2"
    }, cards.map(function(card, cardIndex) {
        return /*#__PURE__*/ React.createElement(EntryAnimation, {
            key: "card-".concat(card.title),
            view: containerRef,
            delay: cardIndex / 10
        }, /*#__PURE__*/ React.createElement(LabeledCallToActionCard, card));
    }))));
}

//# sourceMappingURL=LabeledCallToActionCardsGridSection.js.map